var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaddingTopSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_241)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 14,
    width: 70,
    height: 180,
    rx: 5,
    transform: "rotate(90 188 14)",
    fill: "#007FFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 14,
    width: 70,
    height: 180,
    rx: 5,
    transform: "rotate(90 188 14)",
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3536 21.6464C92.1583 21.4512 91.8417 21.4512 91.6464 21.6464L88.4645 24.8284C88.2692 25.0237 88.2692 25.3403 88.4645 25.5355C88.6597 25.7308 88.9763 25.7308 89.1716 25.5355L92 22.7071L94.8284 25.5355C95.0237 25.7308 95.3403 25.7308 95.5355 25.5355C95.7308 25.3403 95.7308 25.0237 95.5355 24.8284L92.3536 21.6464ZM91.6464 37.3536C91.8417 37.5488 92.1583 37.5488 92.3536 37.3536L95.5355 34.1716C95.7308 33.9763 95.7308 33.6597 95.5355 33.4645C95.3403 33.2692 95.0237 33.2692 94.8284 33.4645L92 36.2929L89.1716 33.4645C88.9763 33.2692 88.6597 33.2692 88.4645 33.4645C88.2692 33.6597 88.2692 33.9763 88.4645 34.1716L91.6464 37.3536ZM91.5 22L91.5 37L92.5 37L92.5 22L91.5 22Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 45L188 79C188 81.7614 185.761 84 183 84L13 84C10.2386 84 8 81.7614 8 79L8 45L188 45Z",
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.653 80.9273C187.877 80.3275 188 79.6781 188 79C188 79.6718 187.836 80.3093 187.543 80.8818L187.653 80.9273ZM185.025 83.8876L184.747 83.2177C184.203 83.4002 183.614 83.5 183 83.5L180.976 83.5L180.976 84.5L182.5 84.5C182.669 84.5 182.835 84.4924 183 84.4776C183.725 84.4123 184.409 84.2065 185.025 83.8876ZM176.929 84.5L176.929 83.5L172.881 83.5L172.881 84.5L176.929 84.5ZM168.833 84.5L168.833 83.5L164.786 83.5L164.786 84.5L168.833 84.5ZM160.738 84.5L160.738 83.5L156.69 83.5L156.69 84.5L160.738 84.5ZM152.643 84.5L152.643 83.5L148.595 83.5L148.595 84.5L152.643 84.5ZM144.548 84.5L144.548 83.5L140.5 83.5L140.5 84.5L144.548 84.5ZM136.452 84.5L136.452 83.5L132.405 83.5L132.405 84.5L136.452 84.5ZM128.357 84.5L128.357 83.5L124.31 83.5L124.31 84.5L128.357 84.5ZM120.262 84.5L120.262 83.5L116.214 83.5L116.214 84.5L120.262 84.5ZM112.167 84.5L112.167 83.5L108.119 83.5L108.119 84.5L112.167 84.5ZM104.071 84.5L104.071 83.5L100.024 83.5L100.024 84.5L104.071 84.5ZM95.9762 84.5L95.9762 83.5L91.9286 83.5L91.9286 84.5L95.9762 84.5ZM87.8809 84.5L87.8809 83.5L83.8333 83.5L83.8333 84.5L87.8809 84.5ZM79.7857 84.5L79.7857 83.5L75.7381 83.5L75.7381 84.5L79.7857 84.5ZM71.6904 84.5L71.6904 83.5L67.6428 83.5L67.6428 84.5L71.6904 84.5ZM63.5952 84.5L63.5952 83.5L59.5476 83.5L59.5476 84.5L63.5952 84.5ZM55.5 84.5L55.5 83.5L51.4523 83.5L51.4523 84.5L55.5 84.5ZM47.4047 84.5L47.4047 83.5L43.3571 83.5L43.3571 84.5L47.4047 84.5ZM39.3095 84.5L39.3095 83.5L35.2618 83.5L35.2618 84.5L39.3095 84.5ZM31.2142 84.5L31.2142 83.5L27.1666 83.5L27.1666 84.5L31.2142 84.5ZM23.119 84.5L23.119 83.5L19.0713 83.5L19.0713 84.5L23.119 84.5ZM15.0237 84.5L15.0237 83.5L13 83.5C12.3855 83.5 11.7969 83.4002 11.2531 83.2177L10.9753 83.8876C11.5914 84.2065 12.2754 84.4123 13 84.4776C13.1647 84.4924 13.3314 84.5 13.5 84.5L15.0237 84.5ZM8.34715 80.9273L8.45685 80.8818C8.16357 80.3093 8 79.6718 8 79C8 79.6781 8.12271 80.3275 8.34715 80.9273ZM188 45.5L188 45L188 44.5L186.043 44.5L186.043 45.5L188 45.5ZM182.13 45.5L182.13 44.5L178.217 44.5L178.217 45.5L182.13 45.5ZM174.304 45.5L174.304 44.5L170.391 44.5L170.391 45.5L174.304 45.5ZM166.478 45.5L166.478 44.5L162.565 44.5L162.565 45.5L166.478 45.5ZM158.652 45.5L158.652 44.5L154.739 44.5L154.739 45.5L158.652 45.5ZM150.826 45.5L150.826 44.5L146.913 44.5L146.913 45.5L150.826 45.5ZM143 45.5L143 44.5L139.087 44.5L139.087 45.5L143 45.5ZM135.174 45.5L135.174 44.5L131.261 44.5L131.261 45.5L135.174 45.5ZM127.348 45.5L127.348 44.5L123.435 44.5L123.435 45.5L127.348 45.5ZM119.522 45.5L119.522 44.5L115.609 44.5L115.609 45.5L119.522 45.5ZM111.696 45.5L111.696 44.5L107.783 44.5L107.783 45.5L111.696 45.5ZM103.87 45.5L103.87 44.5L99.9565 44.5L99.9565 45.5L103.87 45.5ZM96.0435 45.5L96.0435 44.5L92.1305 44.5L92.1305 45.5L96.0435 45.5ZM88.2174 45.5L88.2174 44.5L84.3044 44.5L84.3044 45.5L88.2174 45.5ZM80.3913 45.5L80.3913 44.5L76.4783 44.5L76.4783 45.5L80.3913 45.5ZM72.5653 45.5L72.5653 44.5L68.6522 44.5L68.6522 45.5L72.5653 45.5ZM64.7392 45.5L64.7392 44.5L60.8261 44.5L60.8261 45.5L64.7392 45.5ZM56.9131 45.5L56.9131 44.5L53 44.5L53 45.5L56.9131 45.5ZM49.087 45.5L49.087 44.5L45.174 44.5L45.174 45.5L49.087 45.5ZM41.2609 45.5L41.2609 44.5L37.3479 44.5L37.3479 45.5L41.2609 45.5ZM33.4348 45.5L33.4348 44.5L29.5218 44.5L29.5218 45.5L33.4348 45.5ZM25.6088 45.5L25.6088 44.5L21.6957 44.5L21.6957 45.5L25.6088 45.5ZM17.7827 45.5L17.7827 44.5L13.8696 44.5L13.8696 45.5L17.7827 45.5ZM9.9566 45.5L9.9566 44.5L8 44.5L8 45L8 45.5L9.9566 45.5Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -52,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -52,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 92,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 92,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddingTopSm);
export default __webpack_public_path__ + "static/media/padding_top_sm.bb1c206cfef783d7e0f926e6d9f477c5.svg";
export { ForwardRef as ReactComponent };